import React from 'react';
import { Stack } from '@fiverr-private/layout_components';
import type { Types } from '@fiverr-private/theme';
import type { AttachmentsProps } from './types';
import { renderAttachmentsChildren } from './utils';

const Attachments = ({ children, variant = 'list', goExperimental = false, theme = 'light' }: AttachmentsProps) => {
  const props: Types.FlexLayoutProps =
    variant === 'list' ? { direction: 'column', gap: '1' } : { wrap: 'wrap', columnGap: '4', rowGap: '2' };

  return (
    <Stack role="group" width="100%" {...props}>
      {renderAttachmentsChildren(children, { variant, theme: goExperimental ? 'dark' : theme })}
    </Stack>
  );
};

Attachments.displayName = 'Attachments';
export default Attachments;
